import { useEffect, useState } from "react";
import { api } from "./api";

const BUILTIN = {
  client: [["admin", "Administrator"], ["preparer", "Payroll Preparer"], ["mgt", "MGT (Management / Owner)"], ["viewer", "Viewer"]],
  staff: [["master", "Admin (full access)"], ["officer", "Payroll Officer"], ["readonly", "Read-only"]],
};
const fallback = { client: BUILTIN.client.map(([key, label]) => ({ key, label, builtin: true, base: key })),
                   staff: BUILTIN.staff.map(([key, label]) => ({ key, label, builtin: true, base: key })) };

let cache = null;
let inflight = null;
const listeners = new Set();
const fetchRoles = () => {
  if (cache) return Promise.resolve(cache);
  if (!inflight) inflight = api.get("/settings/roles").then((r) => { cache = r.data; return cache; }).catch(() => fallback).finally(() => { inflight = null; });
  return inflight;
};
export const invalidateRoles = () => { cache = null; fetchRoles().then((d) => listeners.forEach((fn) => fn(d))); };

// Built-in + master-created custom roles for clients and staff. `base(kind, key)` resolves the built-in tier a role behaves like.
export function useRoles() {
  const [data, setData] = useState(cache || fallback);
  useEffect(() => {
    if (!cache) fetchRoles().then(setData);
    listeners.add(setData);
    return () => listeners.delete(setData);
  }, []);
  const find = (kind, key) => (data[kind] || []).find((r) => r.key === key);
  return {
    client: data.client || [], staff: data.staff || [],
    label: (kind, key) => find(kind, key)?.label || key,
    base: (kind, key) => find(kind, key)?.base || key,
    reload: invalidateRoles,
  };
}
